/** Fases do contrato flow → rótulo legível no banner (spec Live Shell). */
export const PHASE_LABELS = {
    preparando: "preparando",
    enviando: "enviando",
    aguardando_resposta: "aguardando resposta",
    avaliando: "avaliando asserts",
    entre_turnos: "próximo turno",
    finalizando: "finalizando",
};

export function phaseLabel(phase) {
    if (phase == null) return "—";
    const key = String(phase).trim();
    return PHASE_LABELS[key] ?? key;
}

export function elapsedSeconds(turnStartedAt, now = Date.now()) {
    const started = Date.parse(turnStartedAt);
    if (Number.isNaN(started)) return 0;
    return Math.max(0, Math.floor((now - started) / 1000));
}

const FlowProgressBanner = ({ progress, now }) => {
    if (!progress) return null;

    const { turnIndex, turnTotal, phase, turnStartedAt } = progress;
    const label = phaseLabel(phase);
    const seconds = elapsedSeconds(turnStartedAt, now ?? Date.now());

    const turnPart =
        turnIndex != null && turnTotal != null
            ? `Turno ${turnIndex}/${turnTotal}`
            : null;

    const parts = [turnPart, label, `${seconds}s`].filter(Boolean);

    return (
        <p
            className="text-xs text-amber-100"
            data-testid="flow-progress-banner"
            aria-live="polite"
        >
            {parts.join(" · ")}
        </p>
    );
};

export default FlowProgressBanner;
